import { render } from "./VerifyEmail.vue?vue&type=template&id=544fc81a&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=544fc81a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544fc81a"]])

export default __exports__